import Link from 'next/link';

export function RoomHeader({ signedIn = false }: { signedIn?: boolean }) {
  return <header className="room-site-header">
    <div className="room-shell room-header-inner">
      <Link href="/" className="room-brand" aria-label="SpeedMixr home">SpeedMixr</Link>
      <nav aria-label="Main navigation" className="room-header-nav">
        <Link href="/realms" className="room-nav-link">Rooms</Link>
        <Link href={signedIn ? '/lobby' : '/login'} className="room-nav-action">{signedIn ? 'My lobby' : 'Sign in'}</Link>
      </nav>
    </div>
  </header>;
}

export function RoomFooter() {
  return <footer className="room-site-footer room-shell"><p>SpeedMixr</p><nav aria-label="Footer"><Link href="/privacy">Privacy</Link><Link href="/terms">Terms</Link></nav></footer>;
}
